import request from '@/utils/request'

//转账记录
export function withdrawTransferList(data) {
    return request({
      url: '/admin/withdrawTransferEth/list',
      method: 'post',
      data: data
    })
  }
  export function totalRecharge(data) {
    return request({
      url: '/admin/tronscanTransfer/totalRecharge',
      method: 'post',
      data: data
    })
  }
  export function tronscanTransferList(data) {
    return request({
      url: '/admin/tronscanTransfer/list',
      method: 'post',
      data: data
    })
  }
// 归集账号管理
export function bnbMasterAccountList(data) {
  return request({
    url: '/admin/ethMasterAccount/list',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountDelete(data) {
  return request({
    url: '/admin/ethMasterAccount/delete',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountSave(data) {
  return request({
    url: '/admin/ethMasterAccount/save',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountUpdate(data) {
  return request({
    url: '/admin/ethMasterAccount/update',
    method: 'post',
    data: data
  })
}
export function getById(data) {
  return request({
    url: '/admin/ethMasterAccount/getById',
    method: 'post',
    data: data
  })
}
export function genNew(data) {
  return request({
    url: '/admin/ethMasterAccount/genNew',
    method: 'post',
    data: data
  })
}
export function importWallet(data) {
  return request({
    url: '/admin/ethMasterAccount/importWallet',
    method: 'post',
    data: data
  })
}

// 归集记录
export function tronscanCollectionList(data) {
    return request({
      url: '/admin/ethCollectionUsdt/list',
      method: 'post',
      data: data
    })
  }
  export function totalAmount(data) {
    return request({
      url: '/admin/ethCollectionUsdt/totalAmount',
      method: 'post',
      data: data
    })
  }
// trx归集记录
export function tronscanCollectionListTrx(data) {
  return request({
    url: '/admin/ethCollectionEth/list',
    method: 'post',
    data: data
  })
}
export function totalAmountTrx(data) {
  return request({
    url: '/admin/ethCollectionEth/totalAmount',
    method: 'post',
    data: data
  })
}
// 提现转账
export function withdrawTransfer(data) {
    return request({
      url: '/admin/withdrawTransferEth/list',
      method: 'post',
      data: data
    })
  }
  export function autoZhuan(data) {
    return request({
      url: '/admin/withdrawTransferEth/autoZhuan',
      method: 'post',
      data: data
    })
  }
  export function updateAutoZhuan(data) {
    return request({
      url: '/admin/withdrawTransferEth/updateAutoZhuan',
      method: 'post',
      data: data
    })
  }
  export function zhuan(data) {
    return request({
      url: '/admin/withdrawTransferEth/zhuan',
      method: 'post',
      data: data
    })
  }
  export function reject(data) {
    return request({
      url: '/admin/withdrawTransferEth/reject',
      method: 'post',
      data: data
    })
  }
  export function zhuanList(data) {
    return request({
      url: '/admin/withdrawTransferEth/zhuanList',
      method: 'post',
      data: data
    })
  }
  export function masterAccounts(data) {
    return request({
      url: '/admin/withdrawTransferEth/masterAccounts',
      method: 'post',
      data: data
    })
  }
  export function applyCount(data) {
    return request({
      url: '/admin/withdrawTransferEth/applyCount',
      method: 'post',
      data: data
    })
  }
  // 用户资金管理
  export function masterAccountsT(data) {
    return request({
      url: '/admin/memberCollectionEth/masterAccounts',
      method: 'post',
      data: data
    })
  }
  export function collectBnb(data) {
    return request({
      url: '/admin/memberCollectionEth/collectEth',
      method: 'post',
      data: data
    })
  }
  export function collect(data) {
    return request({
      url: '/admin/memberCollectionEth/collect',
      method: 'post',
      data: data
    })
  }
  export function zhuanBnb(data) {
    return request({
      url: '/admin/memberCollectionEth/zhuanEth',
      method: 'post',
      data: data
    })
  }
  export function collectTrx(data) {
    return request({
      url: '/admin/memberCollectionEth/collectTrx',
      method: 'post',
      data: data
    })
  }
  export function delegatedEnergy(data) {
    return request({
      url: '/admin/memberCollectionEth/delegatedEnergy',
      method: 'post',
      data: data
    })
  }
  export function undelegateResource(data) {
    return request({
      url: '/admin/memberCollectionEth/undelegateResource',
      method: 'post',
      data: data
    })
  }
  export function oneCollect(data) {
    return request({
      url: '/admin/memberCollectionEth/oneCollect',
      method: 'post',
      data: data
    })
  }
  export function collectView(data) {
    return request({
      url: '/admin/memberCollectionEth/collectView',
      method: 'post',
      data: data
    })
  }
  export function collectList(data) {
    return request({
      url: '/admin/memberCollectionEth/collectList',
      method: 'post',
      data: data
    })
  }
  export function collectListRemove(data) {
    return request({
      url: '/admin/memberCollectionEth/collectListRemove',
      method: 'post',
      data: data
    })
  }
  export function memberCollectionList(data) {
    return request({
      url: '/admin/memberCollectionEth/list',
      method: 'post',
      data: data
    })
  }



  export function memberPayAdList(data) {
    return request({
      url: '/admin/memberPayAd/list',
      method: 'post',
      data: data
    })
  }
  export function memberPayAdPass(data) {
    return request({
      url: '/admin/memberPayAd/pass',
      method: 'post',
      data: data
    })
  }
  export function memberPayAdReject(data) {
    return request({
      url: '/admin/memberPayAd/reject',
      method: 'post',
      data: data
    })
  }
  export function withdrawTransferTotalAmount(data) {
    return request({
      url: '/admin/withdrawTransferEth/totalAmount',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanTotalAmount(data) {
    return request({
      url: '/admin/ethZhuanUsdt/totalAmount',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanList(data) {
    return request({
      url: '/admin/ethZhuanUsdt/list',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanExport(data) {
    return request({
      url: '/admin/ethZhuanUsdt/export',
      method: 'post',
      data: data
    })
  }
  export function batchFreshUSDT(data) {
    return request({
      url: '/admin/memberCollectionEth/batchFreshAsset',
      method: 'post',
      data
    })
  }
  export function withdrawTransferBnbResetStatus(data) {
    return request({
      url: '/admin/withdrawTransferEth/resetStatus',
      method: 'post',
      data
    })
  }
  export function resetStatus(data) {
    return request({
      url: '/admin/memberCollectionEth/resetStatus',
      method: 'post',
      data
    })
  }
  export function freshUSDT(data) {
    return request({
      url: '/admin/memberCollectionEth/freshAsset',
      method: 'post',
      data
    }) 
  }
  // TRX提现转账
  export function listTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/list',
      method: 'post',
      data
    })
  }
  export function totalAmountTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/totalAmount',
      method: 'post',
      data
    })
  }
  export function applyCountTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/applyCount',
      method: 'post',
      data
    })
  }
  export function updateAutoZhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/updateAutoZhuan',
      method: 'post',
      data
    })
  }
  export function zhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/zhuan',
      method: 'post',
      data
    })
  }
  export function rejectTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/reject',
      method: 'post',
      data
    })
  }
  export function zhuanListTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/zhuanList',
      method: 'post',
      data
    })
  }
  export function masterAccountsTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/masterAccounts',
      method: 'post',
      data
    })
  }
  export function autoZhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/autoZhuan',
      method: 'post',
      data
    })
  }
  // TRX转账记录
  export function tronscanZhuanWithdrawTrxList(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/list',
      method: 'post',
      data
    })
  }
  export function tronscanZhuanWithdrawTrxTotalAmount(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/totalAmount',
      method: 'post',
      data
    })
  }
  export function tronscanZhuanWithdrawTrxExport(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/export',
      method: 'post',
      data
    })
  }
  // 其他币种归集记录
  export function bnbCollectionOtherList(data) {
    return request({
      url: '/admin/ethCollectionOther/list',
      method: 'post',
      data
    })
  }
  export function bnbCollectionOtherTotalAmount(data) {
    return request({
      url: '/admin/ethCollectionOther/totalAmount',
      method: 'post',
      data
    })
  }
  export function collectOther(data) {
    return request({
      url: '/admin/memberCollectionEth/collectOther',
      method: 'post',
      data
    })
  }
  export function batchFreshAssetOther(data) {
    return request({
      url: '/admin/memberCollectionEth/batchFreshAssetOther',
      method: 'post',
      data
    })
  }
  export function freshAssetOther(data) {
    return request({
      url: '/admin/memberCollectionEth/freshAssetOther',
      method: 'post',
      data
    })
  }
